import React from 'react';
import { DownloadFile } from 'util';
import styles from './style.module.scss';


const DownloadDiv = (props) => {
    
    const {to} = props;
    const DF = () => {
        const {api, body, name} = to
        DownloadFile({api, body, name})
    }
    return (<div
        {...props}
        className={`${styles.downloadBox}`}
        onClick={DF}
    >
        {props.children}
    </div>)
}

export default DownloadDiv